import ExceptionExamInstructions from './ExceptionExamInstructions'
import IncidentReportSubmission from './IncidentReportSubmission'
import { fetchCourseTypes } from '../../actions/course'
import { getSelectedEducationPeriod } from '../../selectors/settings'

const mapStateToProps = state => {
  const {
    user: {
      data: { selectedOrgId },
    },
    availableCourseTypes: { hasAP, hasPreAP },
  } = state

  return {
    educationPeriodCd: getSelectedEducationPeriod(state),
    orgId: selectedOrgId,
    hasAP,
    hasPreAP,
  }
}

const CoordinatorDashboard = ({
  isCSR,
  educationPeriodCd,
  orgId,
  hasAP = false,
  hasPreAP = false,
  fetchCourseTypes,
}) => {
  let title = ''
  if (hasAP && hasPreAP) {
    title = 'AP & Pre-AP'
  } else if (hasPreAP) {
    title = 'Pre-AP'
  } else {
    title = 'AP'
  }

  useEffect(() => {
    if (orgId && educationPeriodCd) {
      fetchCourseTypes(orgId, educationPeriodCd)
    }
  }, [orgId, educationPeriodCd])

  return (
    <div className="container">
      <h2 className="roboto" style={{ marginBottom: 0, marginTop: 30 }}>
        <a href={isCSR ? '#' : Config.FINE_TUNE_URL} className={isCSR ? 'disabled' : ''}>
          {title} Classroom
        </a>
      </h2>
      <p>
        Access AP coordinator interactive tutorials and AP resources for your teachers and students
      </p>
      <ExceptionExamInstructions />
      <IncidentReportSubmission />
      <h2 className="roboto" style={{ marginBottom: 0, marginTop: 30 }}>
        <a href={isCSR ? '#' : Config.MYAP_URL.prof} className={isCSR ? 'disabled' : ''}>
          Back to MyAP
        </a>
      </h2>
    </div>
  )
}

export default connect(mapStateToProps, { fetchCourseTypes })(CoordinatorDashboard)
